import React from 'react'
import { useDispatch } from 'react-redux'
import {
  Card,
  Grid,
  Typography as Text,
  Divider,
  Button,
} from '@material-ui/core'
import styles from '../WhatsNewStyles'
import { getImageFromFirebaseWithHook } from '../../../../apps/helpers'
import { trackWidgetClick } from '../../../../../helpers/trackWidgetClick'
const WhatsNewCard = ({ itemData }) => {
  const [image, setImage] = React.useState('')
  const classes = styles()
  const dispatch = useDispatch()
  React.useEffect(() => {
    getImageFromFirebaseWithHook(itemData.image, setImage)
  }, [])
  function handleOpenArticle(title) {
    trackWidgetClick(dispatch, 'WhatsNew', title)
    const isLocalhost = window.location.hostname === 'localhost'
    const path = isLocalhost ? '/WhatsNewArticle/' : '/uxp/WhatsNewArticle/'
    const url = `${path}${title}`
    window.open(url, '_blank')
  }
  return (
    <Card variant="outlined" className={classes.itemCardContainer}>
      <Button
        className={classes.cardImageButton}
        onClick={() => handleOpenArticle(itemData.title)}
      >
        <Grid container direction="column" spacing={1}>
          <Grid item className={classes.imageContainer}>
            <img className={classes.image} src={image} alt="" width="100%" />
          </Grid>
          <Grid item>
            <Text variant="h4" style={{ padding: '0px 5px 10px 5px' }}>
              <b>{itemData.title}</b>
            </Text>
            <Divider style={{ margin: '0 8px' }} />
          </Grid>
          <Grid item style={{ margin: '0 8px 8px 8px' }}>
            <Text
              variant="body1"
              component="div"
              className={classes.itemDescription}
              aria-hidden="true"
              dangerouslySetInnerHTML={{ __html: itemData.description }}
            />
          </Grid>
        </Grid>
      </Button>
    </Card>
  )
}

export default WhatsNewCard
